/**
 * Collector version — bumped on any change to signal shape or collection logic.
 *
 * Backend pipelines key off this string to discriminate cohorts during
 * rollout/rollback. Keep semver semantics:
 *   - patch: internal-only changes (no observable signal change)
 *   - minor: new signal added, existing signals untouched
 *   - major: signal removed or shape-broken
 *
 * Typed as a literal so backend SDKs and consumers can narrow on a known
 * version (e.g. discriminated unions per release). Bumping the string also
 * bumps `FingerprintVersion`.
 */
export const VERSION = '0.2.0' as const

export type FingerprintVersion = typeof VERSION
